<template>
  <th scope="col" :class="thClass"></th>
</template>

<script>
import MobileHelper from "@/mixins/MobileHelper";
export default {
  mixins: [MobileHelper],
  computed: {
    thClass() {
      if (this.mobile) {
        return "d-none";
      }
      return "d-none d-sm-table-cell empty-filter";
    },
  },
};
</script>

<style scoped>
th {
  background: rgba(0, 0, 0, 0.06);
}
</style>

